import { render, staticRenderFns } from "./ArchivedForm.vue?vue&type=template&id=0c5e4169"
import script from "./ArchivedForm.vue?vue&type=script&lang=js"
export * from "./ArchivedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports